import React from "react";

const feelings = {
  "happy": { emoji: "😊", label: "Happy" },
  "sad": { emoji: "😢", label: "Sad" },
  "angry": { emoji: "😠", label: "Angry" },
  "excited": { emoji: "🤩", label: "Excited" },
  "grateful": { emoji: "🙏", label: "Grateful" },
  "blessed": { emoji: "🙌", label: "Blessed" },
  "loved": { emoji: "💕", label: "Loved" },
  "thankful": { emoji: "🙏", label: "Thankful" },
  "amazed": { emoji: "😲", label: "Amazed" },
  "proud": { emoji: "😎", label: "Proud" },
  "hopeful": { emoji: "✨", label: "Hopeful" },
  "confident": { emoji: "💪", label: "Confident" },
  "peaceful": { emoji: "😌", label: "Peaceful" },
  "joyful": { emoji: "😄", label: "Joyful" },
  "inspired": { emoji: "💡", label: "Inspired" },
  "motivated": { emoji: "🚀", label: "Motivated" },
  "energetic": { emoji: "⚡", label: "Energetic" },
  "relaxed": { emoji: "😴", label: "Relaxed" },
  "focused": { emoji: "🎯", label: "Focused" },
  "creative": { emoji: "🎨", label: "Creative" },
  "adventurous": { emoji: "🗺️", label: "Adventurous" },
  "curious": { emoji: "🤔", label: "Curious" },
  "surprised": { emoji: "😮", label: "Surprised" },
  "nostalgic": { emoji: "📷", label: "Nostalgic" },
  "romantic": { emoji: "💖", label: "Romantic" }
};

const activities = {
  "traveling": { emoji: "✈️", label: "Traveling" },
  "working": { emoji: "💼", label: "Working" },
  "studying": { emoji: "📚", label: "Studying" },
  "exercising": { emoji: "🏃‍♂️", label: "Exercising" },
  "cooking": { emoji: "👨‍🍳", label: "Cooking" },
  "reading": { emoji: "📖", label: "Reading" },
  "watching": { emoji: "📺", label: "Watching" },
  "listening": { emoji: "🎧", label: "Listening" },
  "playing": { emoji: "🎮", label: "Playing" },
  "shopping": { emoji: "🛒", label: "Shopping" },
  "cleaning": { emoji: "🧹", label: "Cleaning" },
  "gardening": { emoji: "🌱", label: "Gardening" },
  "painting": { emoji: "🎨", label: "Painting" },
  "writing": { emoji: "✍️", label: "Writing" },
  "dancing": { emoji: "💃", label: "Dancing" },
  "singing": { emoji: "🎤", label: "Singing" },
  "photography": { emoji: "📸", label: "Photography" },
  "gaming": { emoji: "🎮", label: "Gaming" },
  "meditation": { emoji: "🧘‍♂️", label: "Meditation" },
  "yoga": { emoji: "🧘‍♀️", label: "Yoga" },
  "running": { emoji: "🏃‍♀️", label: "Running" },
  "cycling": { emoji: "🚴‍♂️", label: "Cycling" },
  "swimming": { emoji: "🏊‍♂️", label: "Swimming" },
  "hiking": { emoji: "🏔️", label: "Hiking" },
  "camping": { emoji: "⛺", label: "Camping" },
  "fishing": { emoji: "🎣", label: "Fishing" },
  "golfing": { emoji: "⛳", label: "Golfing" },
  "tennis": { emoji: "🎾", label: "Tennis" },
  "basketball": { emoji: "🏀", label: "Basketball" },
  "football": { emoji: "⚽", label: "Football" },
  "volleyball": { emoji: "🏐", label: "Volleyball" },
  "baseball": { emoji: "⚾", label: "Baseball" },
  "soccer": { emoji: "⚽", label: "Soccer" },
  "hockey": { emoji: "🏒", label: "Hockey" },
  "boxing": { emoji: "🥊", label: "Boxing" },
  "martial_arts": { emoji: "🥋", label: "Martial Arts" },
  "weightlifting": { emoji: "🏋️‍♂️", label: "Weightlifting" },
  "pilates": { emoji: "🧘‍♀️", label: "Pilates" },
  "zumba": { emoji: "💃", label: "Zumba" },
  "crossfit": { emoji: "💪", label: "CrossFit" },
  "rock_climbing": { emoji: "🧗‍♂️", label: "Rock Climbing" },
  "skateboarding": { emoji: "🛹", label: "Skateboarding" },
  "surfing": { emoji: "🏄‍♂️", label: "Surfing" },
  "skiing": { emoji: "⛷️", label: "Skiing" },
  "snowboarding": { emoji: "🏂", label: "Snowboarding" },
  "ice_skating": { emoji: "⛸️", label: "Ice Skating" },
  "rollerblading": { emoji: "🛼", label: "Rollerblading" },
  "parkour": { emoji: "🤸‍♂️", label: "Parkour" },
  "gymnastics": { emoji: "🤸‍♀️", label: "Gymnastics" },
  "cheerleading": { emoji: "📣", label: "Cheerleading" },
  "marching_band": { emoji: "🎺", label: "Marching Band" },
  "orchestra": { emoji: "🎻", label: "Orchestra" },
  "choir": { emoji: "🎤", label: "Choir" },
  "karaoke": { emoji: "🎤", label: "Karaoke" }
};

export default function PostFeelingActivity({ feeling, activity, className = "", userName = "" }) {
  if (!feeling && !activity) return null;

  return (
    <div className={`post_feeling_activity ${className}`}>
      {feeling && feelings[feeling] && (
        <div className="feeling_display" style={{ color: '#65676B' }}>
          {userName && <span style={{ color: '#050505', fontWeight: '900' }}>{userName} </span>}
          is <span className="notranslate" translate="no">{feelings[feeling].emoji}</span> feeling {feelings[feeling].label.toLowerCase()}
        </div>
      )}
      {activity && activities[activity] && (
        <div className="activity_display" style={{ color: '#65676B' }}>
          {userName && <span style={{ color: '#050505', fontWeight: '900' }}>{userName} </span>}
          is <span className="notranslate" translate="no">{activities[activity].emoji}</span> {activities[activity].label.toLowerCase()}
        </div>
      )}
    </div>
  );
} 